import styled from 'styled-components'
import { Colors } from '~/styles'

const Container = styled.div`
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  font-family: sans-serif;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 1rem;
`

const Th = styled.th`
  margin: 0;
  text-align: left;
  font-weight: 600;
  vertical-align: middle;
  color: ${Colors.modalGrey};
  padding: ${({ size }) => size === 3 ? '8px' : '8px 12px'};
  font-size: ${({ size }) => size === 3 ? '10px' : '1em'};

  p {
    color: ${Colors.softBlue};
    font-size: ${({ size }) => size === 3 ? '12px' : '1em'};
    font-weight: 700;
    margin: 0;
  }

  span {
    color: ${Colors.modalGrey};
    font-size: ${({ size }) => size === 3 ? '10px' : '1em'};
    font-weight: 600;
  }

  b {
    color: ${Colors.cancelTextColor};
    font-size: ${({ size }) => size === 3 ? '10px' : '1em'};
    font-weight: 700;
  }
`

const Td = styled.td`
  color: ${Colors.cancelTextColor};
  border-top: 1px solid #eee;
  vertical-align: middle;
  padding: ${({ size }) => size === 3 ? '8px' : '8px 12px'};
  font-size: ${({ size }) => size === 3 ? '10px' : '1em'};
`

const ColorDot = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.backgroundColor || Colors.grey};
`

const ExpandIcon = styled.span`
  font-size: 12px;
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: 0.2s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const HeaderRow = styled.tr`
  background-color: #f1f1f1;
`
const VesselIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
`

export default {
  Th,
  Td,
  Table,
  ColorDot,
  HeaderRow,
  Container,
  ExpandIcon,
  VesselIcon,
}